<template>
  <section class="wrapper position-relative">
    <div class="overlay" v-if="loading">
      <div>
        <h1 class="text-white text-center display-4">Aguarde</h1>
        <loading-white style="color: white !important" />
      </div>
    </div>
    <div class="container-fluid m-0 p-0">
      <div class="row">
        <div class="col-md-3 d-md-block d-none" style="position: fixed">
          <aside class="d-flex justify-content-between flex-column">
            <img
              src="@/assets/img/logo_60.svg"
              class="img-fluid"
              alt="logo"
              width="200"
            />
            <div class="d-flex justify-content-start align-items-center">
              <i class="material-icons text-success pr-2">person</i>
              <p class="color-blue">{{ dados.nomecomercial }}</p>
            </div>
          </aside>
        </div>
        <div class="col-md-3 d-md-none d-block p-0 m-0">
          <div class="responsive-wrapper">
            <img
              src="@/assets/img/logo_60.svg"
              class="img-fluid"
              alt="logo"
              width="200"
            />
          </div>
        </div>
        <div class="col-md-9 p-3 p-md-5 content offset-md-3">
          <div class="steps">
            <el-steps
              align-center
              finish-status="success"
              direction="horizontal"
              :active="stepInitial"
            >
              <el-step icon="el-icon-house" title="Início"></el-step>
              <el-step
                icon="el-icon-folder-opened"
                title="Documentos"
                v-if="usuario.primeiraDocumentacao"
              ></el-step>
              <el-step
                icon="el-icon-bank-card"
                title="Pagamento"
                v-if="usuario.prestacaoAntecipada"
              ></el-step>
              <el-step icon="el-icon-trophy-1" title="Final"></el-step>
            </el-steps>
          </div>
          <div class="steps-content w-100">
            <div class="card step border-0 w-100" v-show="stepInitial == 0">
              <div class="card-body">
                <h1 class="display-4 color-blue">Olá! Seja bem-vindo.</h1>
                <p class="mt-3 text-muted w-75">
                  Neste painel você poderá desfrutar de todos os produtos e
                  serviços disponibilizados pela CDL/BH. Siga os passos para
                  concluir sua filiação.
                </p>
              </div>
              <div class="card border-0">
                <div
                  class="card-body d-flex d-md-block justify-content-between"
                  v-if="stepInitial < stepsTotal - 1"
                >
                  <button
                    class="btn mr-5 mt-4"
                    v-show="stepInitial != 0"
                    @click="previous"
                  >
                    Anterior
                  </button>
                  <button class="btn btn-verde mt-4" @click="next">
                    Próximo
                  </button>
                </div>
              </div>
            </div>
            <div class="card step border-0 w-100" v-show="stepInitial == 1">
              <div class="card-body">
                <h1 class="display-4 color-blue">Documentos</h1>
                <p class="mt-3 text-muted w-75">
                  Clique no card para selecionar os documentos para envio
                </p>
                <div class="row mt-4">
                  <div
                    class="col mt-3 mt-md-0"
                    v-for="(card, index) in docList[0].docs"
                    :key="index"
                  >
                    <div
                      class="card file-card border-0 shadow"
                      :class="fileNames.includes(card) ? 'complete' : ''"
                    >
                      <div
                        class="card-body d-flex justify-content-between flex-column"
                      >
                        <input
                          type="file"
                          accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                          @change="getFiles(card, $event.target.files)"
                          :ref="'arquivo-' + card"
                          :id="'arquivo-' + card"
                        />
                        <div>
                          <i
                            class="material-icons green"
                            v-if="!fileNames.includes(card)"
                            >description</i
                          >
                          <i class="material-icons green" v-else
                            >check_circle_outline</i
                          >
                          <h3 class="font-weight-bold mt-2 mb-2 text-uppercase">
                            {{ card }}
                          </h3>
                          <small class="small"
                            >Clique neste card para carregar o documento</small
                          >
                        </div>
                        <div></div>
                      </div>
                    </div>
                    <p
                      v-if="fileNames.includes(card)"
                      class="small text-uppercase mt-2 text-danger d-flex remove-btn align-items-center"
                      @click="removeFile(card, index)"
                    >
                      <i class="material-icons mr-2 text-danger"
                        >highlight_off</i
                      >
                      remover arquivo
                    </p>
                  </div>
                </div>
                <p
                  class="mt-3 text-muted text-uppercase w-75 d-flex align-items-center small"
                >
                  Formatos permitidos: png, jpeg e pdf (tamanho máximo de 10MB
                  por arquivo)
                </p>
                <div
                  class="card-body d-flex d-md-block justify-content-between"
                  v-if="stepInitial < stepsTotal - 1"
                >
                  <button
                    class="btn mr-5 mt-4"
                    v-show="stepInitial != 0"
                    @click="previous"
                  >
                    Anterior
                  </button>
                  <button
                    class="btn btn-verde mt-4"
                    :disabled="loading"
                    @click="enviarDocumentos"
                  >
                    <span v-if="!loading"> Enviar arquivos </span>
                    <span v-else> Enviando... </span>
                  </button>
                </div>
              </div>
            </div>

            <div class="card step border-0 w-100" v-show="stepInitial == 2">
              <div class="card-body">
                <h1 class="display-4 color-blue">Pagamento</h1>
                <p class="mt-3 text-muted w-75">
                  Realize o pagamento da sua filiação.
                </p>
                <div class="row">
                  <div class="col-md-5 mb-3 mb-md-0">
                    <div class="pacote p-3" style="min-height: 300px">
                      <p
                        class="small text-uppercase fw-600 d-flex align-items-center"
                      >
                        <i class="material-icons pr-2">article</i> Dados do
                        pacote
                      </p>
                      <hr />
                      <div class="row">
                        <div class="col-md-5">
                          <small class="small">{{
                            usuario.pacoteSocio.nomepacote
                          }}</small>
                        </div>
                        <div class="col-md-7 text-right">
                          <small class="small"
                            >{{
                              usuario.qtdeMensalidades > 1
                                ? usuario.qtdeMensalidades + " Mensalidades"
                                : usuario.qtdeMensalidades + " Mensalidade"
                            }}
                            x R$
                            {{ usuario.planoUnitario | formatPrice }}</small
                          >
                        </div>
                        <div class="col-md-12 pt-5 text-justify">
                          <small class="small">
                            Prezado(a), identificamos uma pendência financeira
                            em seu cadastro. Para finalizarmos a sua filiação,
                            será necessário o pagamento antecipado do valor
                            correspondente às primeiras mensalidades do plano
                            pelo qual optou. Caso necessite de maiores
                            informações, entre em contato pelo e-mail
                            relacionamento@cdlbh.com.br
                          </small>
                        </div>
                      </div>
                      <div class="mt-5">
                        <span class="valor-pacote p-2">
                          <p>Valor Total:</p>
                          <h4 class="h4">
                            R$
                            {{
                              usuario.pacoteSocio.valorlimiteinf | formatPrice
                            }}
                          </h4>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <form action="">
                      <form
                        class="form_padrao pt-2"
                        action
                        @submit.prevent="pagamento"
                      >
                        <div class="form-row">
                          <div class="form-group flutuante col-md-12">
                            <input
                              type="text"
                              name="nome"
                              id="nome"
                              v-model="cartao.nomeCartao"
                              required
                            />
                            <label for="nome">Nome do Titular</label>
                          </div>
                          <div class="form-group flutuante col-md-6">
                            <input
                              type="text"
                              name="numerocartao"
                              id="numerocartao"
                              @keyup="checkFlag"
                              v-model="cartao.numeroCartao"
                              required
                              v-mask="['#### #### #### ####']"
                            />

                            <label for="numerocartao">Número do Cartão</label>
                            <i for="numerocartao" class="flag">
                              <img
                                src="@/assets/img/elo.svg"
                                alt
                                v-if="cartao.bandeira == 'elo'"
                              />
                              <img
                                src="@/assets/img/visa.svg"
                                alt
                                v-if="cartao.bandeira == 'visa'"
                              />
                              <img
                                src="@/assets/img/mastercard.svg"
                                alt
                                v-if="cartao.bandeira == 'mastercard'"
                              />
                              <img
                                src="@/assets/img/hipercard.svg"
                                alt
                                v-if="cartao.bandeira == 'hipercard'"
                              />
                            </i>
                          </div>
                          <div class="form-group flutuante col-md-3">
                            <the-mask
                              type="text"
                              name="anomes"
                              id="anomes"
                              required
                              v-model="cartao.dataExpiracaoCartao"
                              :mask="['##/##']"
                            />
                            <label for="numerocartao">Mês/Ano</label>
                          </div>
                          <div class="form-group flutuante col-md-3">
                            <the-mask
                              type="text"
                              name="anomes"
                              id="anomes"
                              required
                              :mask="['###', '####']"
                              v-model="cartao.codigoValidacaoCartao"
                            />
                            <label for="numerocartao">CCV</label>
                          </div>
                          <div class="form-group col-md-12">
                            <small class="small text-center"
                              >Não possui cartão de crédito?
                              <b
                                style="cursor: pointer"
                                class="font-weight-bolder cursor-pointer"
                                data-toggle="modal"
                                data-target="#chamadoPagamento"
                                >Clique para solicitar outro método de
                                pagamento.</b
                              >
                            </small>
                          </div>
                        </div>
                        <div
                          class="form-row d-flex flex-row justify-content-end align-items-end"
                        >
                          <div
                            class="form-group col-md-12 d-flex flex-row justify-content-end align-items-end"
                          >
                            <button
                              type="submit"
                              class="btn btn-verde p-0 fit-content"
                              :disabled="loading"
                            >
                              <span
                                class="spinner-grow spinner-grow-sm pr-2"
                                role="status"
                                aria-hidden="true"
                                v-show="loading"
                              ></span>
                              <span v-if="loading">Processando</span>
                              <span v-else>Finalizar </span>
                            </button>
                          </div>
                        </div>
                      </form>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div class="card step border-0 w-100" v-show="stepInitial == 3">
              <div class="card-body">
                <h1 class="display-4 color-blue">Obrigado !</h1>
                <div v-if="usuario.lista_fluig[0].codigo == null">
                  <p
                    class="mt-3 mb-3 font-weight-bold text-uppercase w-75 d-flex align-items-center"
                  >
                    <i class="material-icons text-danger mr-1">info</i>
                    Atenção
                  </p>
                  <p class="mt-3 text-muted w-90">
                    Ocorreu um problema na análise do seu cadastro. Por favor
                    entre em contato (31) 3249-1666, para maiores
                    esclarecimentos.
                  </p>
                </div>
                <div v-else>
                  <p class="mt-3 text-muted w-75">
                    Agora precisamos analisar seus dados. Nosso prazo de análise
                    é de 24hrs após a data de envio. Confira abaixo o status dos
                    seus chamados.
                  </p>
                </div>

                <div class="row mt-5">
                  <div
                    class="col-12"
                    id="cardChamadoDocumentos"
                    v-if="usuario.lista_fluig[0].codigo"
                  >
                    <div class="card shadow border-0">
                      <div class="card-body">
                        <i class="material-icons green">flag</i>
                        <p class="font-weight-bold text-uppercase pb-4">
                          Chamado - {{ usuario.lista_fluig[0].codigo }}
                        </p>
                        <small
                          class="small"
                          v-if="usuario.lista_fluig[0].label"
                        >
                          Chamado de Filiação em análise
                        </small>
                        <small class="small" v-else> "Chamado aberto " </small>
                        <p
                          class="pt-3 small"
                          v-if="usuario.lista_fluig[0].status == 0"
                        >
                          <b class="font-weight-bold">Ultima Solução:</b>
                          Chamado de Documentação em análise
                        </p>
                        <p
                          class="pt-3 small"
                          v-else-if="usuario.lista_fluig[0].status == 1"
                        >
                          <b class="font-weight-bold">Ultima Solução:</b>
                          Chamado cancelado, caso necessário entre em contato
                          (31) 3249-1666.
                        </p>
                        <div class="d-flex justify-content-between pt-4">
                          <small class="small text-uppercase">
                            {{
                              usuario.lista_fluig[0].dataAbertura | formatDate
                            }}
                          </small>
                          <small
                            class="small text-uppercase text-success"
                            v-if="usuario.lista_fluig[0].status == 0"
                          >
                            Chamado em análise
                          </small>
                        </div>
                        <div>
                          <div
                            class="row mt-4"
                            v-if="usuario.reenviarDocumentacao"
                          >
                            <div class="col-12">
                              <hr />
                              <p
                                class="mt-3 mb-3 font-weight-bold text-uppercase w-75 d-flex align-items-center"
                              >
                                <i class="material-icons text-danger mr-1"
                                  >info</i
                                >
                                Atenção
                              </p>

                              <p class="mt-3 mb-3 text-muted small w-75">
                                Analisamos sua documentação e identificamos
                                algumas incongruências. Por favor, avalie as
                                mensagens e clique para reenviar os documentos
                                abaixo:
                              </p>
                            </div>
                            <div
                              class="col-md-6 mt-3 mt-md-0"
                              v-for="(
                                card, index
                              ) in usuario.documentacaoReenvio"
                              :key="index"
                            >
                              <div
                                class="card file-card border-0 shadow"
                                :class="
                                  fileNames.includes(card.descatividade)
                                    ? 'complete'
                                    : ''
                                "
                              >
                                <div
                                  class="card-body d-flex justify-content-between flex-column"
                                >
                                  <input
                                    type="file"
                                    accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                                    @change="
                                      getFilesReenvio(
                                        card.descatividade,
                                        card.idatividade,
                                        $event.target.files
                                      )
                                    "
                                    :ref="'arquivo-' + card.idatividade"
                                    :id="'arquivo-' + card.idatividade"
                                  />
                                  <div>
                                    <i
                                      class="material-icons green"
                                      v-if="
                                        !fileNames.includes(card.descatividade)
                                      "
                                      >description</i
                                    >
                                    <i class="material-icons green" v-else
                                      >check_circle_outline</i
                                    >
                                    <h3
                                      class="font-weight-bold mt-2 mb-2 text-uppercase"
                                    >
                                      {{ card.descatividade }}
                                    </h3>
                                    <div
                                      class="d-flex flex-column justify-content-between"
                                    >
                                      <small class="small"
                                        >Status: {{ card.comentarioatividade }}
                                      </small>
                                      <small
                                        v-if="
                                          !fileNames.includes(
                                            card.descatividade
                                          )
                                        "
                                        class="small"
                                        style="
                                          position: absolute;
                                          bottom: 10px;
                                          left: 20px;
                                        "
                                        >clique para carregar</small
                                      >
                                    </div>
                                  </div>
                                  <div></div>
                                </div>
                              </div>
                              <p
                                v-if="fileNames.includes(card.descatividade)"
                                class="small text-uppercase mt-2 text-danger d-flex remove-btn align-items-center"
                                @click="removeFile(card.descatividade, index)"
                              >
                                <i class="material-icons mr-2 text-danger"
                                  >highlight_off</i
                                >
                                remover arquivo
                              </p>
                            </div>
                            <div
                              class="col-12 d-flex flex-column d-md-block justify-content-center"
                            >
                              <p
                                class="mt-3 text-muted text-uppercase w-75 d-flex align-items-center small"
                              >
                                Formatos permitidos: png, jpeg e pdf (tamanho
                                máximo de 10MB por arquivo)
                              </p>

                              <button
                                class="btn btn-verde mt-4"
                                :disabled="loading"
                                @click="reenviarDocumentos"
                              >
                                <span v-if="!loading"> Reenviar arquivos </span>
                                <span v-else> Enviando... </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12"
                    id="cardChamadoPagamento"
                    v-if="usuario.chamadoPgto.codigo"
                  >
                    <div class="card shadow border-0 mt-3">
                      <div class="card-body">
                        <i class="material-icons green">flag</i>
                        <p class="font-weight-bold text-uppercase pb-4">
                          Chamado - {{ usuario.chamadoPgto.codigo }}
                        </p>
                        <small class="small">
                          {{ usuario.chamadoPgto.servico }}
                        </small>
                        <p
                          class="pt-3 small"
                          v-if="usuario.chamadoPgto.ultimasolucao"
                        >
                          <b class="font-weight-bold">Ultima Solução:</b>
                          {{ usuario.chamadoPgto.ultimasolucao }}
                        </p>
                        <div class="d-flex justify-content-between pt-4">
                          <small class="small text-uppercase">
                            {{ usuario.chamadoPgto.dataabertura | formatDate }}
                          </small>
                          <small class="small text-uppercase text-success">
                            {{ usuario.chamadoPgto.status }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom-content">
            <div
              class="col-12 p-3 d-flex justify-content-center text-dark text-center flex-column align-content-center logout"
              @click="logout"
            >
              <i class="material-icons text-danger h1">settings_power</i>
              <p class="text-dark small">Desconectar</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="chamadoPagamento"
      tabindex="-1"
      role="dialog"
      aria-labelledby="chamadoPagamento"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title small text-uppercase"
              id="chamadoPagamentoTitulo"
            >
              Solicitar método de pagamento
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              id="closeModalClick"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="small px-3">
              Por favor, descreva no campo abaixo sua necessidade quanto ao
              pagamento antecipado. atenderemos seu chamado e retornaremos seu
              contato em breve.
            </p>
            <form class="form_padrao pt-2">
              <div class="modal-body">
                <div class="form-row">
                  <div class="form-group flutuante col-md-12">
                    <textarea
                      name="motibo"
                      id="motivo"
                      cols="10"
                      rows="4"
                      v-model="obs"
                    ></textarea>
                    <label for="motibo">Descrição</label>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-verde fit-content"
                  :disabled="loading"
                  @click="abrirChamadoPagamento"
                >
                  <span
                    class="spinner-grow spinner-grow-sm pr-2"
                    role="status"
                    aria-hidden="true"
                    v-show="loading"
                  ></span>
                  <span v-if="loading">Enviando...</span>
                  <span v-else>Enviar solicitação</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
/* eslint-disable no-unreachable */
import { detectFlag } from "../../helpers.js";
export default {
  name: "Filiacao",
  data() {
    return {
      loading: false,
      obs: "",
      cartao: {
        nomeCartao: "",
        numeroCartao: "",
        bandeira: "",
        codigoValidacaoCartao: "",
        dataExpiracaoCartao: "",
        aceite: false,
      },
      stepsTotal: 3,
      stepInitial: 0,
      files: [],
      fileNames: [],
      docList: [
        {
          tipo: "PJ",
          docs: [
            "Contrato Social",
            "Documento de identificacao Societário",
            "Comprovante de Endereco",
          ],
        },
        {
          tipo: "AE",
          docs: [
            "Estatuto",
            "Ata de Nomeação",
            "Documento de identificação do Responsável",
            "Comprovante de Endereço",
          ],
        },
        {
          tipo: "PL",
          docs: [
            "Carteira de Identificação do conselho",
            "Comprovante de Endereço",
          ],
        },
        {
          tipo: "AUT",
          docs: [
            "Inscrição do INSS",
            "Última Contribuição INSS",
            "Documento de Identificação",
            "Comprovante de Endereço",
          ],
        },
        {
          tipo: "MEI",
          docs: [
            "Certificado MEI",
            "Documento de Identificação",
            "Comprovante de Endereço",
          ],
        },
      ],
    };
  },
  watch: {},
  filters: {
    formatDate(valor) {
      var date = new Date(valor);
      var formatter = new Intl.DateTimeFormat("pt-BR");
      return formatter.format(date);
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  computed: {
    ...mapGetters(["usuario", "dados", "coords"]),
  },
  methods: {
    abrirChamadoPagamento() {
      this.loading = true;
      this.$http
        .post(`/api/Ssm/SemPagamentoAntecipado`, {
          valorapagar: "0",
          observacao: this.obs,
        })
        .then((response) => {
          this.$store.dispatch("getUserData");

          setTimeout(() => {
            this.loading = false;
            this.$toast.open({
              message: response.data.mensagem,
              type: "success",
            });
            document.querySelector("#closeModalClick").click();
            this.stepInitial = 3;
          }, 400);
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
          this.$toast.open({
            message: "Falha ao abrir o chamado, por favor tente novamente.",
            type: "error",
          });
        });
    },
    reenviarDocumentos() {
      if (this.files.length < this.usuario.documentacaoReenvio.length) {
        this.$toast.open({
          message: "Você deve adicionar todos os documentos da lista.",
          type: "error",
        });
      } else {
        this.loading = true;
        try {
          this.files.forEach((e) => {
            var fileData = new FormData();
            fileData.append(
              "files",
              e.file[0],
              e.name + e.file[0].name.substr(-4)
            );
            fileData.append("idAtividades", e.idAtividades);
            this.$http
              .post(`/api/Drive/ReenviarDocumentacaoAssociado`, fileData)
              .then((response) => {
                this.$toast.open({
                  message: response.data.mensagem,
                  type: "success",
                });

                this.files = [];
                this.fileNames = [];
                var filesInput = document.querySelectorAll("input");
                filesInput.forEach((e) => {
                  e.value = null;
                });

                this.loading = false;
                this.$store.dispatch("getUserData");
              })
              .catch((error) => {
                console.error(error);
                this.$toast.open({
                  message: "Erro no envio dos seus arquivos, tente novamente.",
                  type: "error",
                });
                this.loading = false;
              });
          });
        } catch (error) {
          this.loading = false;
          this.$toast.open({
            message: "Erro no envio dos seus arquivos, tente novamente.",
            type: "error",
          });
        }
      }
    },
    enviarDocumentos() {
      if (this.files.length < this.docList[0].docs.length) {
        this.$toast.open({
          message: "Você deve adicionar todos os documentos da lista.",
          type: "error",
        });
      } else {
        this.loading = true;
        const files = new FormData();

        this.files.forEach((el) => {
          files.append(
            "files",
            el.file[0],
            el.name + el.file[0].name.substr(-4)
          );
        });
        this.$http
          .post(`/api/Drive/AnexarDocumentacaoAssociado`, files)
          .then((response) => {
            this.$store.dispatch("getUserData");
            this.$toast.open({
              message: response.data.mensagem,
              type: "success",
            });

            this.files = [];
            this.fileNames = [];
            var filesInput = document.querySelectorAll("input");
            filesInput.forEach((e) => {
              e.value = null;
            });
            this.loading = false;
            if (this.usuario.prestacaoAntecipada) {
              this.stepInitial = 2;
            } else {
              this.stepInitial = 3;
            }
          })
          .catch((error) => {
            console.error(error);
            this.$toast.open({
              message: "Erro no envio dos seus arquivos, tente novamente.",
              type: "error",
            });
            this.loading = false;
          });
      }
    },
    pagamento() {
      if (this.cartao.aceite) {
        this.loading = true;

        var dataset = {
          nomeCartao: this.cartao.nomeCartao,
          numeroCartao: this.cartao.numeroCartao.replace(/\s/g, ""),
          dataExpiracaoCartao: this.cartao.dataExpiracaoCartao,
          codigoValidacaoCartao: this.cartao.codigoValidacaoCartao,
        };

        this.$http
          .post("/api/PagarMe/RegistrarPagamentoAntecipado", dataset)
          .then((response) => {
            this.$toast.open({
              message: response.data.mensagem,
              type: "success",
            });
            this.loading = false;
            this.stepInitial = 3;
            this.$store.dispatch("getUserData");
          })
          .catch(() => {
            this.loading = false;
            this.$toast.open({
              message:
                "Erro ao processar seu pagamento, verifique os dados do cartão.",
              type: "error",
            });
          });
      } else {
        this.$toast.open({
          message:
            "Você deve aceitar os termos de adesão para realizar o pagamento.",
          type: "error",
        });
      }
    },
    abrirChamado() {},
    checkFlag() {
      if (this.cartao.numeroCartao.replace(/\s/g, "").length >= 14) {
        this.cartao.bandeira = detectFlag(
          this.cartao.numeroCartao.replace(/\s/g, "")
        );
      } else {
        this.cartao.bandeira = "";
      }
    },
    removeFile(name) {
      this.files.splice(name, 1);
      this.fileNames.splice(name, 1);
      document.getElementById("arquivo-" + name).value = null;
    },
    getFiles(name, file) {
      this.renameFile(file, name);
      this.fileNames.push(name);
      this.files.push({ name, file });
    },
    getFilesReenvio(name, idAtividades, file) {
      this.fileNames.push(name);
      this.files.push({ name, idAtividades, file });
    },
    renameFile(originalFile, newName) {
      return new File([originalFile], newName, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      });
    },
    next() {
      this.stepInitial++;
    },
    nextArquivos() {
      this.stepInitial++;
      if (this.usuario.primeiraDocumentacao) {
        if (!this.files.length) {
          this.$toast.open({
            message: "Você deve adicionar todos os documentos para upload.",
            type: "error",
          });
        } else {
          this.stepInitial++;
        }
      } else {
        this.stepInitial++;
      }
    },
    previous() {
      if (this.stepInitial != 0) {
        this.stepInitial--;
      }
    },
    getGeo() {
      if (!sessionStorage.latitude) {
        var getPosition = function (options) {
          return new Promise(function (resolve, reject) {
            navigator.geolocation.getCurrentPosition(resolve, reject, options);
          });
        };
        getPosition()
          .then((position) => {
            this.$store.commit("UPDATE_WEATHER", position.coords);
            sessionStorage.latitude = position.coords.latitude;
            sessionStorage.longitude = position.coords.longitude;
          })
          .then(() => {})
          .catch((err) => {
            console.error(err.message);
          });
      }
    },
    getIP() {
      if (!sessionStorage.ip) {
        fetch(process.env.VUE_APP_IP_API + "?format=json")
          .then((x) => x.json())
          .then(({ ip }) => {
            sessionStorage.ip = ip;
          });
      }
    },
    async logout() {
      await this.$store.dispatch("LOGOUT");
      //await this.$router.push({ name: "login" });
      window.location.replace("https://cdlbh.com.br");
    },
  },
  mounted() {
    this.docList = this.docList.filter(
      (e) => e.tipo == this.usuario.tp_empresa.trim()
    );
  },
  created() {
    this.getIP();
    this.getGeo();
    if (!this.usuario.primeiraDocumentacao) {
      if (this.usuario.prestacaoAntecipada) {
        this.stepInitial = 2;
      } else {
        this.stepInitial = 3;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  background: white;
  .overlay {
    position: fixed;
    width: 100%;
    height: 100vh;
    z-index: 300;
    background: rgba(0, 0, 0, 0.4);
    top: 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background 0.2s ease-in-out;
  }
  .responsive-wrapper {
    background-image: url("../../assets/img/bg.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  aside {
    background-image: url("../../assets/img/bg.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    padding: 2rem;
    height: 100vh;
  }
  .content {
    height: 100%;
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    .steps {
      width: 100%;
    }
    .logout {
      cursor: pointer;
    }
    .steps-content {
      .step {
        .pacote {
          background: #05428e;
          color: white;
          margin-top: 10px;
          padding: 10px;
          height: 100%;
          position: relative;
          i {
            font-size: 14px;
            color: #00a04e;
          }
          .valor-pacote {
            position: absolute;
            bottom: 0px;
            left: 10px;
            h4 {
              color: #fecc0d;
            }
          }
        }
        .flag {
          position: absolute;
          width: 100%;
          left: 80%;
          top: 50%;
          transform: translateY(-50%);
          opacity: 0.5;
          font-size: 15px;
          pointer-events: none;
          transition: all 0.25s ease;
          img {
            width: 40px;
          }
        }
        .remove-btn {
          cursor: pointer;
        }
        min-height: 200px;
        .complete {
          background: #00a04e;
          color: white;
          i {
            color: white;
          }
        }
        .file-card {
          min-height: 200px;
          transition: all 0.2s ease-in-out;
          position: relative;
          cursor: pointer;
          input[type="file"] {
            cursor: pointer;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
            z-index: 2;
          }
          &:hover {
            transform: translateY(-5px);
          }
        }
      }
    }
  }
}
body {
  background: white !important;
}
</style>
<style>
.el-step__title {
  font-size: 14px !important;
}

@media screen and (max-width: 900px) {
  .el-step__title {
    display: none;
  }
  h1 {
    font-size: 2rem !important;
    margin-top: 2rem !important;
  }
}
</style>
